import {Fragment, h} from "preact";
import {Link} from "preact-router/match";
import s from "../../routes/LoginPage/OnboardingLayout/onboardingLayout.module.css";
import {nadOnboarding1, nadOnboarding2, nadOnboarding3, nadOnboarding4} from "../../assets";
import {useAppContext} from "../../contexts";

const OnboardingContent = (props) => {
    // Destructured props
    const {logoSrc} = props;

    // Retrieves some app data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={`font-museo`}>
                <div className={"h-full flex items-center gap-x-4"}>
                    <Link
                        href="/"
                        data-testid="header-logo-link"
                        className={`${s.logoContainer} ${highContrast ? s.logoYellowFilter : ""}`}
                    >
                        <img
                            src={logoSrc}
                            className={`${s.sabinLogo}`}
                            alt={"Sabin logo"}
                            data-testid="header-logo-img"
                        />
                    </Link>
                    <p
                        className={`${s.storeCall} ${highContrast ? "highLabelFourth" : ""}`}
                        style={{fontSize: `16px`}}
                    >
                        |&nbsp;&nbsp;Loja virtual
                    </p>
                </div>
                <h1 className={`${s.heading}`}>
                    Agora ficou ainda mais facil realizar seus exames
                </h1>
                <ul className={`${s.stepList}`}>
                    <li className={`${s.step}`}>
                        <div>
                            <img
                                src={nadOnboarding1}
                                alt="Icon"
                            />
                        </div>
                        <p>
                            Faça seu login ao lado;
                        </p>
                    </li>
                    <li className={`${s.step}`}>
                        <div>
                            <img
                                src={nadOnboarding2}
                                alt="Icon"
                            />
                        </div>
                        <p>
                            Escolha quem vai realizar os exames;
                        </p>
                    </li>
                    <li className={`${s.step}`}>
                        <div>
                            <img
                                src={nadOnboarding3}
                                alt="Icon"
                            />
                        </div>
                        <p>
                            Envie o pedido médico;
                        </p>
                    </li>
                    <li className={`${s.step}`}>
                        <div>
                            <img
                                src={nadOnboarding4}
                                alt="Icon"
                            />
                        </div>
                        <p>
                            Pronto, vamos enviar um orçamento por e-mail para você.
                        </p>
                    </li>
                </ul>
            </div>
        </Fragment>
    )
}

export default OnboardingContent;
